import Breadcrumb from '../Component/Breadcrumb'
const Library = () => {
  return (
    <>
      <Breadcrumb breadtitle="Library" breadmid="Facilities" breadend="Library" />
      <div className="innerpage library_blk">
        <div className="container">
          <div class="row">
            
            <div class="col-xl-12 col-lg-6 col-md-12">
              <div class="content">
                <ul className='list-view'>
                  <li>All the students are encouraged to develop the habit of reading and reflection. The Library is well-equipped with books on various subjects and of various types.</li>
                  <li>No book should be carowied out of the Library without the permission of the Librarian and its issue duly registered.</li>
                  <li>Strict silence should be observed in the Library at all times in order not to disturb others.</li>
                  <li>Students should carefully handle the books provided by the Library. No Pages or pictures should be removed from the books. Any damage done to the books and magazines or those lost by the borowower are to be replaced, or the full cost of these is to be paid to the Librarian.</li>
                  <li>If the borowower finds a book damaged, she/he should inform the Librarian before borowowing it.</li>
                  <li>Books are issued only to the students. They are not to lend them to other.</li>
                  <li>Failure to return a book in the due date incurs a fine of Rs. 5 per day for the time the book is
                    overdue.</li>
                  <li>Books, magazines, dictionaries, atlases, maps etc. taken for reference should be put back in the
                    same place.</li>
                  <li>All the books should be returned to the library 3 days before the Annual Exam No Books will be
                    issued during this period.</li>
                  <li>Students are highly recommended to take the guidance of teachers in selecting books.</li>
                </ul>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-12">
              <div class="img-box">
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/lib1.jpg"><img alt="Canossa School Lucknow" class="img-fluid" src="https://webapi.entab.info/api/image/CSFL/public/images/lib1.jpg" /></a>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-12">
              <div class="img-box">
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/lib2.jpg"><img alt="Canossa School Lucknow" class="img-fluid" src="https://webapi.entab.info/api/image/CSFL/public/images/lib2.jpg" /></a>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-md-12">
              <div class="img-box">
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/lib3.jpg"><img alt="Canossa School Lucknow" class="img-fluid" src="https://webapi.entab.info/api/image/CSFL/public/images/lib3.jpg" /></a>
              </div>
            </div>

            <div class="col-xl-4 col-lg-6 col-md-12">
              <div class="img-box">
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/lib4.jpg"><img alt="Canossa School Lucknow" class="img-fluid" src="https://webapi.entab.info/api/image/CSFL/public/images/lib4.jpg" /></a>
              </div>
            </div>
            <div class="col-xl-4 col-lg-6 col-md-12">
              <div class="img-box">
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/CSFL/public/images/lib5.jpg">
                  <img alt="Canossa School Lucknow" class="img-fluid" src="https://webapi.entab.info/api/image/CSFL/public/images/lib5.jpg" /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Library